import { useEffect } from 'react';
import { useParams, useNavigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supportedLangs, defaultLang } from '@/i18n';

export default function LocaleLayout() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!lang || !supportedLangs.includes(lang)) {
      const saved = localStorage.getItem('i18nextLng');
      const detected = saved && supportedLangs.includes(saved) ? saved : defaultLang;
      navigate(`/${detected}`, { replace: true });
      return;
    }
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
  }, [lang, i18n, navigate]);

  if (!lang || !supportedLangs.includes(lang)) return null;

  return <Outlet />;
}
